<script setup>
// Masifi: paywall of the webhooks page that works on self-hosted (pattern of SamlPaywall.vue). Upstream's
// WebhookPaywall always renders the Chatwoot Cloud variant (billing button), which on Masifi would point to a page
// that does not exist: here the client admin is told to contact the provider and the owner (SuperAdmin) gets the
// link to Super Admin, where api_and_webhooks is enabled per account (Masifi::AccountAddons).
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import BasePaywallModal from 'dashboard/routes/dashboard/settings/components/BasePaywallModal.vue';

const router = useRouter();
const currentUser = useMapGetter('getCurrentUser');
const { accountId, isOnChatwootCloud } = useAccount();

const isSuperAdmin = computed(() => currentUser.value?.type === 'SuperAdmin');
const i18nKey = computed(() =>
  isOnChatwootCloud.value ? 'PAYWALL' : 'ENTERPRISE_PAYWALL'
);

const openBilling = () => {
  router.push({
    name: 'billing_settings_index',
    params: { accountId: accountId.value },
  });
};
</script>

<template>
  <div class="grid place-content-center w-full h-full max-h-[28rem] mx-auto">
    <BasePaywallModal
      class="mx-auto"
      feature-prefix="INTEGRATION_SETTINGS.WEBHOOK"
      :i18n-key="i18nKey"
      :is-super-admin="isSuperAdmin"
      :is-on-chatwoot-cloud="isOnChatwootCloud"
      @upgrade="openBilling"
    />
  </div>
</template>
